/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Constants } from 'app/core/models/constants';
import { StringUtilities } from 'app/shared/helpers/string-helpers';
import moment from 'moment';
import { formatAsString } from '../helpers/date-helpers';
@Injectable({ providedIn: 'root' })
export class CookieService {
	constructor(@Inject(DOCUMENT) private document: Document) {}

	get(name: string): string | null {
		const match = this.document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		return match ? decodeURIComponent(match[2]) : null;
	}

	set(name: string, value: string, days: number = 365, path: string = '/') {
		const expires = new Date(Date.now() + days * 86400000).toUTCString();
		this.document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=${path}`;
	}

	delete(name: string, path: string = '/') {
		this.document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}`;
	}

	getLoggedInUserId(): number {
		const v = this.get(Constants.Cookies.KeyLoggedInUserId);
		return v ? +v : -1;
	}

	getDeviceId(): string {
		const existing = this.get(Constants.Cookies.KeyDeviceId);
		if (existing) return existing;

		const guid = StringUtilities.generateNewGuid();
		this.set(Constants.Cookies.KeyDeviceId, guid, 365);
		return guid;
	}

	getUserDateTime(date) {
		const dateString = formatAsString(moment(date), 'YYYY-MM-DD @ HH:mm:ss');
		return '<i><strong>[' + this.getLoggedInFullName() + ': ' + dateString + ']</strong></i>';
	}

	getLoggedInFullName(): string {
		return this.get(Constants.Cookies.KeyLoggedInFullName) || '';
	}
	setLoggedInUserType(userType: number): void {
		this.set(Constants.Cookies.KeyLoggedInUserType, userType.toString());
	}

	getLoggedInUserType(): number {
		const v = this.get(Constants.Cookies.KeyLoggedInUserType);
		return v ? +v : -1;
	}
	getLoggedInUserName(): string {
		return this.get(Constants.Cookies.KeyLoggedInUserName) || '';
	}

	getOrganiserId(): string {
		return this.get(Constants.Cookies.KeyOrganiserId) || '';
	}
	setOrganiserId(organiserId: any): void {
		this.set(Constants.Cookies.KeyOrganiserId, organiserId.toString());
	}

	setLoggedInFullName(fullName: string): void {
		this.set(Constants.Cookies.KeyLoggedInFullName, fullName);
	}
	setLoggedInUserId(userId: number): void {
		this.set(Constants.Cookies.KeyLoggedInUserId, userId.toString());
	}
	setLoggedInUserName(userName: string): void {
		this.set(Constants.Cookies.KeyLoggedInUserName, userName);
	}
	isOffline(): boolean {
		return this.get(Constants.Offline.KeyOfflineStatus) === Constants.Offline.IsOffline;
	}
}

// @Injectable({ providedIn: 'root' })
// export class CookieService {
// 	constructor(
// 		@Inject(DOCUMENT) private document: Document,
// 		private stringUtilities: StringUtilities
// 	) {}

// 	/** Get a cookie value by name */
// 	get(name: string): string | null {
// 		const match = this.document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
// 		return match ? decodeURIComponent(match[2]) : null;
// 	}

// 	/** Set a cookie with optional expiry (days) */
// 	set(name: string, value: string, days: number = 365, path: string = '/') {
// 		const expires = new Date(Date.now() + (days || 365) * 86400000).toUTCString();
// 		this.document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=${path}`;
// 	}

// 	/** Delete a cookie */
// 	delete(name: string, path: string = '/') {
// 		this.document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}`;
// 	}

// 	/** Offline/online helpers */

// 	isOnline(): boolean {
// 		return !this.isOffline();
// 	}

// 	goOffline(): void {
// 		this.set(Constants.Offline.KeyOfflineStatus, Constants.Offline.IsOffline);
// 	}

// 	goOnline(): void {
// 		this.set(Constants.Offline.KeyOfflineStatus, Constants.Offline.IsOnline);
// 	}

// 	/** Logged-in user info */
// 	getLoggedInUserId(): number {
// 		const v = this.get(Constants.Cookies.KeyLoggedInUserId);
// 		return v ? +v : -1;
// 	}

// 	getLoggedInUserType(): number {
// 		const v = this.get(Constants.Cookies.KeyLoggedInUserType);
// 		return v ? +v : -1;
// 	}

// 	getLoggedInFullName(): string {
// 		return this.get(Constants.Cookies.KeyLoggedInFullName) || '';
// 	}

// 	getOrganiserId(): string {
// 		return this.get(Constants.Cookies.KeyOrganiserId) || '';
// 	}

// 	setLoggedInUserType(userType: number): void {
// 		this.set(Constants.Cookies.KeyLoggedInUserType, userType.toString());
// 	}

// 	setLoggedInFullName(fullName: string): void {
// 		this.set(Constants.Cookies.KeyLoggedInFullName, fullName);
// 	}

// 	setOrganiserId(organiserId: any): void {
// 		this.set(Constants.Cookies.KeyOrganiserId, organiserId.toString());
// 	}

// 	/** Device ID handling (persistent cookie) */
// 	getDeviceId(): string {
// 		const existing = this.get(Constants.Cookies.KeyDeviceId);
// 		if (existing) return existing;

// 		const guid = this.stringUtilities.generateNewGuid();
// 		this.set(Constants.Cookies.KeyDeviceId, guid, 365);
// 		return guid;
// 	}

//   	/** Generates a user-specific date/time string */
// 	getUserDateTime(date: Date): string {
// 		const v = this.get(Constants.Cookies.KeyLoggedInUserId);
// 		// Example: include user ID in timestamp or timezone info
// 		const userId = this.getLoggedInUserId();
// 		const pad = (n: number) => n.toString().padStart(2, '0');
// 		return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ` + `@ ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())} (UID:${userId})`;
// 	}
// }
